import { Box, useLayoutContext } from "arkh";
import React from "react";
import { PILL_INDICATOR_SIZE } from "../../PillIndicator";

export function WorkspaceRoutineItemRowContainer(props: {
  title: React.ReactNode;
  status: React.ReactNode;
  freq: React.ReactNode;
  issueCount: React.ReactNode;
  more: React.ReactNode;
  topic?: React.ReactNode;
}) {
  const layout = useLayoutContext();
  return (
    <Box style={{ flexDirection: "row", alignItems: "center" }}>
      <Box style={{ flex: 1, flexDirection: "row", alignItems: "center" }}>
        <Box style={{ width: props.topic ? "40%" : "50%" }} spaceRight="medium">
          {props.title}
        </Box>
        <Box
          style={{ width: props.topic ? "20%" : "25%", minWidth: 100 }}
          spaceRight="medium"
        >
          {props.freq}
        </Box>
        <Box
          style={{
            width: props.topic ? "20%" : "25%",
            flexDirection: "row",
            alignItems: "center",
            minWidth: 100,
          }}
          spaceRight="medium"
        >
          {props.issueCount}
        </Box>
        {props.topic ? (
          <Box style={{ width: "20%", minWidth: 100 }} spaceRight="small">
            {props.topic}
          </Box>
        ) : null}
      </Box>
      <Box
        style={{
          width: PILL_INDICATOR_SIZE.width + layout.space.medium,
          alignItems: "flex-end",
        }}
      >
        {props.status}
      </Box>
      <Box style={{ width: 20 }}>{props.more}</Box>
    </Box>
  );
}
